// @flow
import * as React from 'react';

const handleBeforeUnload = (e) => {
    // const confirmationMessage = true;
    e.preventDefault();
    (e || window.event).returnValue = '';
    return '';
};

const registerBeforeUnloadListener = () => {
    window.addEventListener('beforeunload', handleBeforeUnload);
};

const unregisterBeforeUnloadListener = () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
};

const ConfirmBeforeUnload = () => {
    React.useEffect(() => {
        registerBeforeUnloadListener();
        return unregisterBeforeUnloadListener;
    }, []);

    return null;
};

export default ConfirmBeforeUnload;
